import { useEffect, useMemo, useState } from 'react'
import { Alert, Button, ConfigProvider } from 'antd'
import { onUpgradeRequired } from '../api/upgradeBus.ts'
import { useDarkMode } from '../hooks/useDarkMode.tsx'
import { BRAND, getAntdTheme } from '../theme/antdTheme.ts'

// Banner shown when an API call returns 402/403 (no subscription / not
// permitted): the user's token is valid but their plan doesn't cover the
// feature. Links to the account upgrade page (URL provided by the backend).

export const UpgradePlate = () => {
    const [url, setUrl] = useState<string | null>(null)
    const { darkModeEnabled } = useDarkMode()

    const themeConfig = useMemo(() => {
        const base = getAntdTheme(darkModeEnabled)
        return { ...base, token: { ...base.token, colorWarning: BRAND.magenta } }
    }, [darkModeEnabled])

    useEffect(() => onUpgradeRequired(setUrl), [])

    if (!url) return null

    return (
        <ConfigProvider theme={themeConfig}>
            <Alert
                type="warning"
                showIcon
                closable
                onClose={() => setUrl(null)}
                message="Upgrade required"
                description="Your plan doesn't include this feature. Upgrade your Bitquery account to continue."
                action={
                    <Button size="small" type="primary" href={url} target="_blank" rel="noopener noreferrer">
                        Upgrade
                    </Button>
                }
                style={{
                    position: 'fixed',
                    top: 12,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 2000,
                    maxWidth: 560,
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                }}
            />
        </ConfigProvider>
    )
}
